export const skillsetCourse = [
    {
        id: 1,
        title: "美容SKM",
        description: "",
        type: "offline",
        instructor: {
            id: "",
            name: "政府承认的技术证",
            avatar: "",
            rating: 4.9,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/1.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "Pls Ask",
        seats: ""
    },
    {
        id: 2,
        title: "其他SKM",
        description: "",
        type: "offline",
        instructor: {
            id: "gov3",
            name: "政府承认的技术认证",
            avatar: "",
            rating: 4.8,
        },
        date: " ",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/2.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "Pls Ask",
        seats: ""
    },
    {
        id: 3,
        title: "头发 SKM",
        description: "",
        type: "offline",
        instructor: {
            id: "gov2",
            name: "政府承认的技术证",
            avatar: "",
            rating: 5.0,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/3.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "Pls Ask",
        seats: ""
    },
    {
        id: 4,
        title: "头疗 SKM",
        description: "",
        type: "offline",
        instructor: {
            id: "gov",
            name: "政府承认的技术证",
            avatar: "",
            rating: 4.7,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/4.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "Pls Ask",
        seats: "Limited enrollment"
    },
    {
        id: 5,
        title: "罗马粉嫩技术班",
        description: "",
        type: "offline",
        instructor: {
            id: "tasha",
            name: "Tasha Yuet (马), Chris Toh (马)",
            avatar: "",
            rating: 4.8,
        },
        date: " ",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/5.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 499",
        seats: ""
    },
    {
        id: 6,
        title: "美发重塑管理",
        description: "",
        type: "offline",
        instructor: {
            id: "christoh",
            name: "Chris Toh (马), Cho JunSung (韩)",
            avatar: "",
            rating: 5.0,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "",
        image: "/images/skillset/6.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "Pls Ask",
        seats: ""
    },
    {
        id: 7,
        title: "头疗店长培训班",
        description: "",
        type: "offline",
        instructor: {
            id: "yun",
            name: "云舒老师(台湾)",
            avatar: "",
            rating: 4.7,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/7.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "Pls Ask",
        seats: "Limited enrollment"
    },
    {
        id: 8,
        title: "头疗实操技能班",
        description: "",
        type: "offline",
        instructor: {
            id: "yun2",
            name: "云舒老师(台湾)",
            avatar: "",
            rating: 4.8,
        },
        date: " ",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/8.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "Pls Ask",
        seats: ""
    },
    {
        id: 9,
        title: "头皮疗愈师全能班",
        description: "",
        type: "offline",
        instructor: {
            id: "tte",
            name: "TTE主导老师(台湾)",
            avatar: "",
            rating: 5.0,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "",
        image: "/images/skillset/9.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "Pls Ask",
        seats: ""
    },
    // {
    //     id: 11,
    //     title: "Luxury Makeup Masterclass",
    //     description: "",
    //     type: "offline",
    //     instructor: {
    //         id: "",
    //         name: "Sarah Johnson",
    //         avatar: "",
    //         rating: 4.9,
    //     },
    //     date: "Coming Soon",
    //     time: "TBC",
    //     venue: "",
    //     image: "/images/skillset/11.jpeg",
    //     registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
    //     price: "RM 4800",
    //     seats: ""
    // },
    {
        id: 12,
        title: "肌肤重塑培训课",
        description: "",
        type: "offline",
        instructor: {
            id: "lizho",
            name: "Liz Ho (马)",
            avatar: "",
            rating: 4.8,
        },
        date: " ",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/12.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 499",
        seats: ""
    },
    {
        id: 13,
        title: "订制脱毛技巧课",
        description: "",
        type: "offline",
        instructor: {
            id: "lizho",
            name: "Liz Ho (马)",
            avatar: "",
            rating: 5.0,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/13.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 399",
        seats: ""
    },
    {
        id: 14,
        title: "高清喷枪底妆进修班",
        description: "",
        type: "offline",
        instructor: {
            id: "Kathryn",
            name: "Kathryn(马) ",
            avatar: "",
            rating: 4.7,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "Johor",
        image: "/images/skillset/14.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 499",
        seats: "Limited enrollment"
    },
    {
        id: 15,
        title: "形象体态美学班",
        description: "",
        type: "offline",
        instructor: {
            id: "evelyn",
            name: "Evenlyn(马) ",
            avatar: "",
            rating: 4.8,
        },
        date: " ",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/15.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 399",
        seats: ""
    },
    {
        id: 16,
        title: "芳疗课程基础班",
        description: "",
        type: "offline",
        instructor: {
            id: "alice",
            name: "Alice Liew(马)",
            avatar: "",
            rating: 5.0,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/16.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 399",
        seats: ""
    },
    {
        id: 17,
        title: "美甲美睫马来市场班",
        description: "",
        type: "offline",
        instructor: {
            id: "fiona",
            name: "Fiona Oh（马）",
            avatar: "",
            rating: 4.7,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/17.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 249",
        seats: "Limited enrollment"
    },
    {
        id: 18,
        title: "颂锑自我疗愈能量学",
        description: "",
        type: "offline",
        instructor: {
            id: "madam",
            name: "Madam Ng(马)",
            avatar: "",
            rating: 4.8,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "",
        image: "/images/skillset/18.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 999",
        seats: ""
    },
    {
        id: 19,
        title: "颂锑疗愈实战课",
        description: "",
        type: "offline",
        instructor: {
            id: "master",
            name: "Master Ng(马)",
            avatar: "",
            rating: 5.0,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/19.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 999",
        seats: ""
    },
    {
        id: 20,
        title: "专业临床头皮学（基础课）",
        description: "",
        type: "offline",
        instructor: {
            id: "carienne",
            name: "Carienne Hew(新加坡)",
            avatar: "",
            rating: 4.7,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "Singapore",
        image: "/images/skillset/20.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 249",
        seats: "Limited enrollment"
    },
    {
        id: 21,
        title: "美甲界的技术革命",
        description: "",
        type: "offline",
        instructor: {
            id: "vanience",
            name: "Vanience Ong(马)",
            avatar: "",
            rating: 4.9,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "Johor",
        image: "/images/skillset/21.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 4800",
        seats: ""
    },
    {
        id: 22,
        title: "美甲界的技术革命",
        description: "",
        type: "offline",
        instructor: {
            id: "evone",
            name: "Evone Tan",
            avatar: "",
            rating: 4.8,
        },
        date: " ",
        time: "TBC",
        venue: "Perak",
        image: "/images/skillset/22.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 4800",
        seats: ""
    },
    {
        id: 23,
        title: "美甲界的技术革命",
        description: "",
        type: "offline",
        instructor: {
            id: "bubu",
            name: "Bubu Angee(马)",
            avatar: "",
            rating: 5.0,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "Penang",
        image: "/images/skillset/23.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 4800",
        seats: ""
    },
    {
        id: 24,
        title: "染发系统课",
        description: "",
        type: "offline",
        instructor: {
            id: "聪聪",
            name: "聪聪(M)",
            avatar: "",
            rating: 5.0,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/24.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 4800",
        seats: ""
    },
    // {
    //     id: 25,
    //     title: "专业临床头皮学（基础课）",
    //     description: "",
    //     type: "offline",
    //     instructor: {
    //         id: "carienne",
    //         name: "Carienne Hew",
    //         avatar: "",
    //         rating: 4.7,
    //     },
    //     date: "Coming Soon",
    //     time: "TBC",
    //     venue: "Singapore",
    //     image: "/images/skillset/25.jpeg",
    //     registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
    //     price: "RM 249",
    //     seats: "Limited enrollment"
    // },
    {
        id: 26,
        title: "美甲短期课程",
        description: "",
        type: "offline",
        instructor: {
            id: "joan",
            name: "Joan Ng(马)",
            avatar: "",
            rating: 4.9,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/26.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 4800",
        seats: ""
    },
    {
        id: 27,
        title: "专业新娘课程",
        description: "",
        type: "offline",
        instructor: {
            id: "Kathryn",
            name: "Kathryn Lee",
            avatar: "",
            rating: 4.8,
        },
        date: " ",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/27.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 4800",
        seats: ""
    },
    {
        id: 28,
        title: "专业美睫课程",
        description: "",
        type: "offline",
        instructor: {
            id: "chiaki",
            name: "Chiaki Sabata(马)",
            avatar: "",
            rating: 5.0,
        },
        date: "Coming Soon",
        time: "TBC",
        venue: "KL",
        image: "/images/skillset/28.jpeg",
        registrationUrl: "https://api.whatsapp.com/send/?phone=60162677356&text=我想请问课程&type=phone_number&app_absent=0",
        price: "RM 4800",
        seats: ""
    },
]
// Helper function to get upcoming courses
export const getCourse = () => {
    const now = new Date()
    return skillsetCourse.filter(course => new Date(course.date) > now)
}